export default "__VITE_ASSET__BF7nJNBM__"